import { CategoryMapListPage } from "@/features/channel-category/pages/CategoryMapListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-map/")({
	component: CategoryMapListPage,
});
